import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
} from '@angular/forms';
import { ComponentBase } from '~/infrastructure/component-base';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { LocationsService } from '~/services/modules/stocks/locations';
import { DateTimePickerComponent } from '@progress/kendo-angular-dateinputs';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { FormatService } from '~/services/administration.ts/format';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';

@Component({
    selector: 'app-stock-stock-to-asset',
    templateUrl: './stock-to-asset.html',
    styleUrls: ['./stock-to-asset.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockStockToAssetComponent extends ComponentBase implements OnInit {

    @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
    @ViewChild('kendo_combo_accounts') kendoComboAccounts: ComboBoxComponent;
    @ViewChild('kendo_combo_location') kendoComboLocations: ComboBoxComponent;
    _costFormat: string;
    _currentUser: UserSummary;
    _theme: string;
    _form: FormGroup;
    _invalidForm: boolean;
    _addClassActiveLocation: boolean = false;
    _addClassActiveGrid: boolean = false;
    _selectedLocations: any[] = [];
    _locations: any[] = [];
    _locationsFiltered: any[];
    _sortingSelected = new FormControl('old');

    _datePickerFormat: string;

    _dateEnabled: boolean;

    public _stockToAssetGridData: any[] = [
        {
            inventoryId: '0',
            assetId: '15470',
            stockDescription: "description 1",
            model: '15470',
            serial: "SE125874",
            fromLocation: "Location 7",
            availableQty: '45',
            issueUOM: "EA",
            inventoryUnitQty: '223',
            qtyVariance: '14'
        },
        {
            inventoryId: '1',
            assetId: '15470',
            stockDescription: "description 2",
            model: '15470',
            serial: "SE125874",
            fromLocation: "Location 7",
            availableQty: '45',
            issueUOM: "EA",
            inventoryUnitQty: '223',
            qtyVariance: '14'
        },
        {
            inventoryId: '2',
            assetId: '15470',
            stockDescription: "description 3",
            model: '15470',
            serial: "SE125874",
            fromLocation: "Location 7",
            availableQty: '45',
            issueUOM: "EA",
            inventoryUnitQty: '223',
            qtyVariance: '14'
        },
    ];


    isGeneralInformationExpanded: boolean = true;
    isScanInventoryExpanded: boolean = true;

    constructor(
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _layoutComponent: LayoutComponent,
        private _layoutManager: LayoutManagerService,
        private _securityService: SecurityService,
        private _locationsService: LocationsService,
        private _formatService: FormatService,
        private _TransactionDateEditting: TransactionDateEditingService
    ) {
        super();
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });

        this._currentUser = this._securityService.currentUser;
    }

    ngOnInit() {
        this._initForm();
        this._LoadLocation(1); // to send login site
        this._OpenAccount();
        /** Format */
        this._datePickerFormat = this._formatService.dateFormat;
        this._costFormat = this._formatService.costFormatValue;
        this.getDateEnabledOption();

        this._sortingSelected.valueChanges.subscribe((x) => {
            this._stockToAssetGridData.reverse();
        });
    }
    _OpenAccount() {
        if (this._currentUser.isEnterprise) {
            setTimeout(() => {
                this.kendoComboAccounts.toggle(true);
                this.kendoComboAccounts.focus();
            });
        }
        else {
            setTimeout(() => {
                this.kendoComboLocations.toggle(true);
                this.kendoComboLocations.focus();
            });
        }
    }
    _LoadLocation(siteId: number) {
        return this._locationsService.getLocationListingBySite(siteId)
            .subscribe((data: any) => {
                this._locations = data;
                this._locationsFiltered = data;
            });
    }
    _onLocationChange(e: any) {
        this._selectedLocations = e.selectedFields;
    }
    private _initForm() {
        this._form = this._fb.group({
            startDate: new Date(),
            endDate: new Date()
        });
    }
    _onSave(e: any) {
        if (!this._stockToAssetGridData.length) {
            this._layoutComponent.openPopup({
                title: 'Validation',
                message: 'Please add the items you want to Receive.',
                withoutConfirm: true
            });
        } else if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;
            const formModel = this._form.value;
            let model: any = {};
            model['startDate'] = formModel.startDate;
            model['endDate'] = formModel.endDate;
        }
    }
    _onClear() {
        this._form.setValue({
            startDate: new Date(),
            endDate: new Date()
        });
    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }
    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }


    ExpandCollapseGeneralInfoWidget(isExpand: boolean) {
        this.isGeneralInformationExpanded = !isExpand;
    }


    ExpandCollapseScanInventoryWidget(isExpand: boolean) {
        this.isScanInventoryExpanded = !isExpand;
    }


    getDateEnabledOption() {
        this._TransactionDateEditting.getTransactionDateEditing("get-data")

            .subscribe((x: any) => {
                this._dateEnabled = x.transactionDateEditing;
            })
    }

}
